import React, { useState, useEffect } from "react";
import { HiPencil, HiTrash, HiPlus, HiOutlineUserGroup } from "react-icons/hi";
import { FaMinusCircle, FaPlusCircle, FaSearch, FaUserCheck, FaUserTimes } from "react-icons/fa";
import { FiUser, FiPhone, FiMail, FiMapPin, FiTag, FiFacebook, FiInstagram, FiTwitter, FiLinkedin, FiCodepen, FiYoutube, FiBriefcase, FiUserPlus, FiUpload } from "react-icons/fi";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function CustomerDatatable() {
  // State management
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [userId, setUserId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [rolemanagement, setRoleManagement] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Countries, states, cities data
  const [countries] = useState([
    {
      id: 1,
      name: "India",
      code: "IN",
      states: [
        {
          id: 4001,
          name: "Andhra Pradesh",
          state_code: "AP",
          districts: [
            "Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna",
            "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam",
            "Vizianagaram", "West Godavari", "YSR Kadapa"
          ]
        },
        {
          id: 4002,
          name: "Tamil Nadu",
          state_code: "TN",
          districts: [
            "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore",
            "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kancheepuram",
            "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam",
            "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram",
            "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur",
            "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupathur",
            "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore",
            "Viluppuram", "Virudhunagar"
          ]
        },
        {
          id: 4003,
          name: "Karnataka",
          state_code: "KA",
          districts: [
            "Bagalkot", "Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban",
            "Bidar", "Chamarajanagar", "Chikballapur", "Chikkamagaluru", "Chitradurga",
            "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan",
            "Haveri", "Kalaburagi", "Kodagu", "Kolar", "Koppal",
            "Mandya", "Mysuru", "Raichur", "Ramanagara", "Shivamogga",
            "Tumakuru", "Udupi", "Uttara Kannada", "Vijayapura", "Yadgir"
          ]
        }
      ]
    },
    {
      id: 2,
      name: "United States",
      code: "US",
      states: [
        {
          id: 1001,
          name: "California",
          state_code: "CA",
          districts: ["Los Angeles", "San Diego", "San Jose", "San Francisco", "Fresno"]
        },
        {
          id: 1002,
          name: "Texas",
          state_code: "TX",
          districts: ["Houston", "San Antonio", "Dallas", "Austin", "Fort Worth"]
        }
      ]
    }
  ]);

  // User form states - FIXED: Added all fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    whatsapp: "",
    gender: "",
    status: "Active",
    photo: null,
    dob: null,
    addressLine1: "",
    addressLine2: "",
    city: "",
    district: "",
    state: "",
    country: "India",
    pincode: "",
    companyName: "",
    businessType: "",
    gstNumber: "",
    panNumber: "",
    businessAddress: "",
    website: "",
    facebook: "",
    instagram: "",
    twitter: "",
    linkedin: "",
    behance: "",
    youtube: "",
    ReferredBy: "",
    Remarks: "",
    Language: "",
    Tags: ""
  });

  // UI toggle states
  const [showBusinessDetails, setShowBusinessDetails] = useState(false);
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [showTagsDetails, setShowTagsDetails] = useState(false);
  
  // Data states
  const [districts, setDistricts] = useState([]);
  const [states, setStates] = useState(countries[0].states);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [tags, setTags] = useState([]);

  // Customer counts
  const [customerCounts, setCustomerCounts] = useState({
    total: 0,
    active: 0,
    inactive: 0
  });

  // Base URL for API
  const API_BASE_URL = "http://localhost:5890";

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle file upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (file.size > 2 * 1024 * 1024) {
      toast.warn("Image size should be less than 2MB");
      return;
    }
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.warn("Please upload an image file");
      return;
    }
    
    setFormData(prev => ({
      ...prev,
      photo: file
    }));
  };

  // Fetch user role from token
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setRoleManagement(payload.role || "User"); 
      } catch (err) {
        console.error("Invalid token", err);
        setRoleManagement("User");
      }
    }
  }, []);

  // Fetch users data
  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("No authentication token found");
        setIsLoading(false);
        return;
      }

      const response = await axios.get(
        `${API_BASE_URL}/GETMENSTIONAPI/Bussiness_all_details`, 
        { 
          headers: { 
            Authorization: `Bearer ${token}` 
          } 
        }
      );

      console.log("API Response:", response.data);
      
      const usersData = Array.isArray(response.data?.customers) ? response.data.customers : [];
      setUsers(usersData);
      
      // Calculate customer counts
      const activeCount = usersData.filter(user => user?.status === "Active").length;
      const inactiveCount = usersData.filter(user => user?.status === "Inactive" || !user?.status).length;
      
      setCustomerCounts({
        total: usersData.length,
        active: activeCount,
        inactive: inactiveCount
      });
      
      setIsLoading(false);
    } catch (err) {
      console.error("Fetch error", err);
      toast.error("❌ Failed to fetch users: " + (err.response?.data?.message || err.message));
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Fetch business types
  useEffect(() => {
    const fetchBusinessTypes = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await axios.get(`${API_BASE_URL}/Bussinesstype`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setBusinessTypes(res.data || []);
      } catch (err) {
        console.error("Error fetching business types:", err);
        toast.warn("Could not load business types");
      }
    };
    fetchBusinessTypes();
  }, []);

  // Fetch languages
  useEffect(() => {
    const fetchLanguageTypes = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await axios.get(`${API_BASE_URL}/prefenenceLanguage`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setLanguages(res.data || []);
      } catch (err) {
        console.error("Error fetching languages:", err);
        toast.warn("Could not load languages");
      }
    };
    fetchLanguageTypes();
  }, []);

  // Fetch tags
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await axios.get(`${API_BASE_URL}/Tagsandlabels`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setTags(res.data || []);
      } catch (err) {
        console.error("Error fetching tags:", err);
        toast.warn("Could not load tags");
      }
    };
    fetchTags();
  }, []);

  // Filter users based on search
  const filteredUsers = users.filter(user => {
    const searchTerm = search.toLowerCase().trim();
    const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();
    return (
      fullName.includes(searchTerm) ||
      (user?.email?.toLowerCase() || "").includes(searchTerm) ||
      (user?.phone?.includes(search) || "")
    );
  });

  // Reset form
  const resetForm = () => {
    setUserId(null);
    setIsEditing(false);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      whatsapp: "",
      gender: "",
      status: "Active",
      photo: null,
      dob: null,
      addressLine1: "",
      addressLine2: "",
      city: "",
      district: "",
      state: "",
      country: "India",
      pincode: "",
      companyName: "",
      businessType: "",
      gstNumber: "",
      panNumber: "",
      businessAddress: "",
      website: "",
      facebook: "",
      instagram: "",
      twitter: "",
      linkedin: "",
      behance: "",
      youtube: "",
      ReferredBy: "",
      Remarks: "",
      Language: "",
      Tags: ""
    });
    setDistricts([]);
    setStates(countries[0].states);
    setShowBusinessDetails(false);
    setShowOtherDetails(false);
    setShowTagsDetails(false);
  };

  // Handle country change
  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    handleInputChange(e);
    
    const selectedCountry = countries.find(c => c.name === countryName);
    const countryStates = selectedCountry?.states || [];
    setStates(countryStates);
    setDistricts([]);
    
    // Reset state and district
    setFormData(prev => ({
      ...prev,
      state: "",
      district: ""
    }));
  };

  // Handle state change
  const handleStateChange = (e) => {
    const stateName = e.target.value;
    handleInputChange(e);
    
    const selectedState = states.find(s => s.name === stateName);
    setDistricts(selectedState?.districts || []);
    
    // Reset district
    setFormData(prev => ({
      ...prev,
      district: ""
    }));
  };

  // Handle form submission - FIXED VERSION
  const handleAddOrEditUser = async () => {
    // Validate required fields
    if (!formData.firstName?.trim()) {
      toast.warn("⚠️ First Name is required");
      return;
    }

    if (!formData.email?.trim()) {
      toast.warn("⚠️ Email is required");
      return;
    }

    if (!formData.phone?.trim()) {
      toast.warn("⚠️ Phone number is required");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.warn("⚠️ Please enter a valid email address");
      return;
    }

    // Phone validation (basic)
    const phoneRegex = /^[0-9]{10,15}$/;
    const cleanPhone = formData.phone.replace(/\D/g, '');
    if (!phoneRegex.test(cleanPhone)) {
      toast.warn("⚠️ Please enter a valid phone number (10-15 digits)");
      return;
    }

    const formDataToSend = new FormData();

    // Prepare all fields with proper values
    const fieldMappings = {
      firstName: formData.firstName.trim(),
      lastName: formData.lastName?.trim() || "",
      email: formData.email.trim(),
      phone: cleanPhone,
      whatsapp: formData.whatsapp?.replace(/\D/g, '') || cleanPhone,
      gender: formData.gender || "",
      status: formData.status || "Active",
      dob: formData.dob ? new Date(formData.dob).toISOString().split('T')[0] : "",
      addressLine1: formData.addressLine1?.trim() || "",
      addressLine2: formData.addressLine2?.trim() || "",
      city: formData.city?.trim() || "",
      district: formData.district?.trim() || "",
      state: formData.state?.trim() || "",
      country: formData.country?.trim() || "India",
      pincode: formData.pincode?.trim() || "",
      companyName: formData.companyName?.trim() || "",
      businessType: formData.businessType?.trim() || "",
      gstNumber: formData.gstNumber?.trim() || "",
      panNumber: formData.panNumber?.trim() || "",
      businessAddress: formData.businessAddress?.trim() || "",
      website: formData.website?.trim() || "",
      facebook: formData.facebook?.trim() || "",
      instagram: formData.instagram?.trim() || "",
      twitter: formData.twitter?.trim() || "",
      linkedin: formData.linkedin?.trim() || "",
      behance: formData.behance?.trim() || "",
      youtube: formData.youtube?.trim() || "",
      ReferredBy: formData.ReferredBy?.trim() || "",
      Language: formData.Language?.trim() || "",
      Remarks: formData.Remarks?.trim() || "",
      Tags: formData.Tags?.trim() || ""
    };

    // Append all fields to FormData
    Object.entries(fieldMappings).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataToSend.append(key, value);
      }
    });

    // Append photo file if exists
    if (formData.photo instanceof File) {
      formDataToSend.append("photo", formData.photo);
    }

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("Authentication required");
        return;
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      };

      let response;
      if (isEditing && userId) {
        response = await axios.put(`${API_BASE_URL}/Bussiness_edit_details/${userId}`, formDataToSend, config);
        toast.success("🎉 Customer updated successfully!");
      } else {
        response = await axios.post(`${API_BASE_URL}/Bussiness_add_details`, formDataToSend, config);
        toast.success("🎉 Customer added successfully!");
      }
      
      console.log("API Response:", response.data);
      
      // Close modal
      const modalElement = document.getElementById("addUserModal");
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        if (modal) modal.hide();
      }
      
      // Reset form and refresh data
      resetForm();
      fetchUsers();
      
    } catch (error) {
      console.error("Submission error:", error);
      
      let errorMessage = "Failed to submit form";
      if (error.response) {
        // Server responded with error
        errorMessage = error.response.data?.message || 
                      error.response.data?.error || 
                      JSON.stringify(error.response.data);
      } else if (error.request) {
        // No response received
        errorMessage = "No response from server. Please check your connection.";
      } else {
        // Request setup error
        errorMessage = error.message;
      }
      
      toast.error(`❌ ${errorMessage}`);
    }
  };

  // Edit user handler - FIXED VERSION
  const handleEditUser = (user) => {
    console.log("Editing user:", user);
    
    setIsEditing(true);
    setUserId(user.id || user._id);
    
    // Set form data from user object
    setFormData({
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      email: user.email || "",
      phone: user.phone || "",
      whatsapp: user.whatsapp || "",
      gender: user.gender || "",
      status: user.status || "Active",
      photo: user.photo, // Keep the existing photo URL
      dob: user.dob ? new Date(user.dob) : null,
      addressLine1: user.addressLine1 || "",
      addressLine2: user.addressLine2 || "",
      city: user.city || "",
      district: user.district || "",
      state: user.state || "",
      country: user.country || "India",
      pincode: user.pincode || "",
      companyName: user.companyName || "",
      businessType: user.businessType || "",
      gstNumber: user.gstNumber || "",
      panNumber: user.panNumber || "",
      businessAddress: user.businessAddress || "",
      website: user.website || "",
      facebook: user.facebook || "",
      instagram: user.instagram || "",
      twitter: user.twitter || "",
      linkedin: user.linkedin || "",
      behance: user.behance || "",
      youtube: user.youtube || "",
      ReferredBy: user.ReferredBy || "",
      Remarks: user.Remarks || "",
      Language: user.Language || "",
      Tags: user.Tags || ""
    });

    // Set states and districts based on country
    if (user.country) {
      const countryObj = countries.find(c => c.name === user.country);
      if (countryObj) {
        setStates(countryObj.states || []);
        
        if (user.state) {
          const stateObj = countryObj.states.find(s => s.name === user.state);
          setDistricts(stateObj?.districts || []);
        }
      }
    }

    // Open modal
    const modalElement = document.getElementById("addUserModal");
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  };

  // Delete user handler
  const handleDeleteUser = async (id) => {
    if (!window.confirm("Are you sure you want to delete this customer?")) {
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("Authentication required");
        return;
      }

      await axios.delete(
        `${API_BASE_URL}/Bussiness_delete_details/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      toast.success("🗑️ Customer deleted successfully");
      fetchUsers();
    } catch (err) {
      console.error("Delete error:", err);
      const errorMsg = err.response?.data?.message || "Failed to delete customer";
      toast.error(`❌ ${errorMsg}`);
    }
  };

  // Get full image URL
  const getImageUrl = (photoPath) => {
    if (!photoPath) {
      return "https://ui-avatars.com/api/?name=Customer&background=random&size=40";
    }
    
    // Check if it's already a full URL
    if (photoPath.startsWith('http')) {
      return photoPath;
    }
    
    // Check if it starts with uploads/
    if (photoPath.startsWith('uploads/')) {
      return `${API_BASE_URL}/${photoPath}`;
    }
    
    // Otherwise, assume it's just a filename
    return `${API_BASE_URL}/uploads/${photoPath}`;
  };

  // Get user's full name
  const getUserFullName = (user) => {
    return `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Unknown Customer';
  };

  // Get preview image source
  const getPreviewImage = () => {
    if (formData.photo instanceof File) {
      return URL.createObjectURL(formData.photo);
    } else if (formData.photo) {
      return getImageUrl(formData.photo);
    }
    return null;
  };

  // Cleanup preview URL
  useEffect(() => {
    return () => {
      if (formData.photo instanceof File && getPreviewImage()) {
        URL.revokeObjectURL(getPreviewImage());
      }
    };
  }, [formData.photo]);

  return (
    <div className="container-fluid px-4" style={{ 
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      paddingTop: '20px',
      paddingBottom: '40px'
    }}>
      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        style={{ marginTop: '70px' }}
      />
      
      {/* Main Content */}
      <div className="card border-0 shadow-sm rounded-3" style={{
        border: '1px solid rgba(0,0,0,0.1)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        <div className="card-body p-0 m-1">
          {/* Header Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center p-4 border-bottom" style={{
            backgroundColor: '#ffffff',
            borderBottom: '1px solid rgba(0,0,0,0.08)'
          }}>
            <h2 className="h5 fw-bold mb-3 mb-md-0" style={{
              color: '#2c3e50',
              fontSize: '1.5rem',
              display: 'flex',
              alignItems: 'center'
            }}>
              <FiUser size={"40px"} className="me-2" style={{ color: '#3498db' }} />
              Customer Management
            </h2>
            
            <div className="d-flex flex-column flex-sm-row align-items-stretch gap-3 w-100 w-md-auto">
              <div className="position-relative flex-grow-1" style={{ maxWidth: "400px" }}>
                <div className="input-group" style={{
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <span className="input-group-text bg-white border-end-0" style={{
                    padding: '0.575rem 1rem',
                    color: '#7f8c8d'
                  }}>
                    <FaSearch />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0"
                    placeholder="Search by name, email or phone..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      borderColor: '#e0e0e0',
                      padding: '0.575rem 1rem',
                      fontSize: '0.9rem',
                      height: 'auto'
                    }}
                  />
                </div>
              </div>
              
              <button
                className="btn btn-success d-flex align-items-center gap-2 px-4 shadow-sm"
                data-bs-toggle="modal"
                data-bs-target="#addUserModal"
                onClick={resetForm}
                style={{
                  borderRadius: '8px',
                  fontWeight: '500',
                  padding: '0.575rem 1.5rem',
                  transition: 'all 0.3s ease',
                  backgroundColor: '#2ecc71',
                  border: 'none',
                  boxShadow: '0 2px 4px rgba(46, 204, 113, 0.2)',
                  height: '100%'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#27ae60'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#2ecc71'}
              >
                <HiPlus size={18} />
                Add Customer
              </button>
            </div>
          </div>
          
          {/* Customer Stats Cards */}
          <div className="row mb-4 px-4 pt-4" style={{ marginLeft: 0, marginRight: 0 }}>
            <div className="col-md-4 mb-3" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
              <div className="card text-white shadow-sm h-100" style={{
                border: 'none',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #3498db, #2980b9)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }} onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(52, 152, 219, 0.3)';
              }} onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(52, 152, 219, 0.2)';
              }}>
                <div className="card-body d-flex align-items-center" style={{ padding: '1.5rem' }}>
                  <div className="me-3" style={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <HiOutlineUserGroup size={30} />
                  </div>
                  <div>
                    <h6 className="card-subtitle mb-1" style={{ 
                      opacity: 0.9,
                      fontSize: '0.85rem',
                      fontWeight: '500'
                    }}>Total Customers</h6>
                    <h3 className="card-title mb-0" style={{ 
                      fontSize: '2rem',
                      fontWeight: '700',
                      marginTop: '0.25rem'
                    }}>{customerCounts.total}</h3>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-4 mb-3" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
              <div className="card text-white shadow-sm h-100" style={{
                border: 'none',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #2ecc71, #27ae60)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }} onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(46, 204, 113, 0.3)';
              }} onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(46, 204, 113, 0.2)';
              }}>
                <div className="card-body d-flex align-items-center" style={{ padding: '1.5rem' }}>
                  <div className="me-3" style={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FaUserCheck size={30} />
                  </div>
                  <div>
                    <h6 className="card-subtitle mb-1" style={{ 
                      opacity: 0.9,
                      fontSize: '0.85rem',
                      fontWeight: '500'
                    }}>Active Customers</h6>
                    <h3 className="card-title mb-0" style={{ 
                      fontSize: '2rem',
                      fontWeight: '700',
                      marginTop: '0.25rem'
                    }}>{customerCounts.active}</h3>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-4 mb-3" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
              <div className="card text-white shadow-sm h-100" style={{
                border: 'none',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }} onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(231, 76, 60, 0.3)';
              }} onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(231, 76, 60, 0.2)';
              }}>
                <div className="card-body d-flex align-items-center" style={{ padding: '1.5rem' }}>
                  <div className="me-3" style={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <FaUserTimes size={30} />
                  </div>
                  <div>
                    <h6 className="card-subtitle mb-1" style={{ 
                      opacity: 0.9,
                      fontSize: '0.85rem',
                      fontWeight: '500'
                    }}>Inactive Customers</h6>
                    <h3 className="card-title mb-0" style={{ 
                      fontSize: '2rem',
                      fontWeight: '700',
                      marginTop: '0.25rem'
                    }}>{customerCounts.inactive}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Loading State */}
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading customers...</p>
            </div>
          ) : (
            /* Users Table */
            <div className="table-responsive" style={{ padding: '0 1.5rem' }}>
              <table className="table table-hover align-middle mb-0" style={{
                borderCollapse: 'separate',
                borderSpacing: '0 12px'
              }}>
                <thead className="table-light" style={{
                  backgroundColor: '#f8f9fa',
                  borderBottom: '1px solid #e0e0e0',
                  position: 'sticky',
                  top: 0,
                  zIndex: 10
                }}>
                  <tr>
                    <th className="ps-4" style={{
                      padding: '1rem',
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderTopLeftRadius: '12px',
                      borderBottomLeftRadius: '12px'
                    }}>Customer</th>
                    <th style={{
                      padding: '1rem',
                      fontWeight: '600',
                      color: '#2c3e50'
                    }}><FiMail className="me-1" /> Email</th>
                    <th style={{
                      padding: '1rem',
                      fontWeight: '600',
                      color: '#2c3e50'
                    }}><FiPhone className="me-1" /> Phone</th>
                    <th style={{
                      padding: '1rem',
                      fontWeight: '600',
                      color: '#2c3e50'
                    }}>Status</th>
                    <th className="text-end pe-4" style={{
                      padding: '1rem',
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderTopRightRadius: '12px',
                      borderBottomRightRadius: '12px'
                    }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <tr key={user.id || user._id} style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                        transition: 'all 0.3s ease'
                      }} onMouseOver={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }} onMouseOut={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}>
                        <td className="ps-4" style={{
                          padding: '1rem',
                          borderTopLeftRadius: '12px',
                          borderBottomLeftRadius: '12px'
                        }}>
                          <div className="d-flex align-items-center gap-3">
                            <div className="position-relative">
                              <img
                                src={getImageUrl(user.photo)}
                                alt="User"
                                className="rounded-circle border"
                                width="40"
                                height="40"
                                style={{
                                  objectFit: 'cover',
                                  borderColor: '#e0e0e0 !important'
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(getUserFullName(user)) + "&background=random&size=40";
                                }}
                              />
                              {user.status === "Active" && (
                                <span className="position-absolute bottom-0 end-0 p-1 bg-success border border-2 border-white rounded-circle"></span>
                              )}
                            </div>
                            <div>
                              <div className="fw-semibold" style={{ color: '#2c3e50' }}>
                                {getUserFullName(user)}
                              </div>
                              <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                                {user.companyName ? `${user.companyName} • ${user.businessType}` : "Customer"}
                              </small>
                            </div>
                          </div>
                        </td>
                 <td style={{ padding: '1rem' }}>
  <div
    className="text-truncate"
    style={{
      maxWidth: "200px",
      color: '#34495e',
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: "pointer"
    }}
    title={user.email || "No email"}
  >
    {user.email
      ? user.email.length > 10
        ? user.email.substring(0, 10) + "..."
        : user.email
      : "No email"}
  </div>
</td>
                        <td style={{ 
                          padding: '1rem',
                          color: '#34495e'
                        }}>{user.phone || "No phone"}</td>
                        <td style={{ padding: '1rem' }}>
                          <span className={`badge rounded-pill ${user.status === "Active" ? "bg-success" : "bg-secondary"}`} style={{
                            padding: '0.5em 0.8em',
                            fontWeight: '500',
                            fontSize: '0.75rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {user.status || "Inactive"}
                          </span>
                        </td>
                        <td className="text-end pe-4" style={{
                          padding: '1rem',
                          borderTopRightRadius: '12px',
                          borderBottomRightRadius: '12px'
                        }}>
                          <div className="d-flex gap-2 justify-content-end">
                            <button
                              className={`btn btn-sm btn-outline-primary rounded-circle ${!["Admin", "Manager"].includes(rolemanagement) ? "disabled opacity-50" : ""}`}
                              onClick={() => handleEditUser(user)}
                              disabled={!["Admin", "Manager"].includes(rolemanagement)}
                              title="Edit"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.3s ease',
                                borderWidth: '1.5px'
                              }}
                              onMouseOver={(e) => {
                                if (!e.currentTarget.disabled) {
                                  e.currentTarget.style.backgroundColor = '#3498db';
                                  e.currentTarget.style.color = 'white';
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!e.currentTarget.disabled) {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.color = '#3498db';
                                }
                              }}
                            >
                              <HiPencil size={24} />
                            </button>
                            <button
                              className={`btn btn-sm btn-outline-danger rounded-circle ${rolemanagement !== "Admin" ? "disabled opacity-50" : ""}`}
                              onClick={() => handleDeleteUser(user.id || user._id)}
                              disabled={rolemanagement !== "Admin"}
                              title="Delete"
                              style={{
                               
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.3s ease',
                                borderWidth: '1.5px'
                              }}
                              onMouseOver={(e) => {
                                if (!e.currentTarget.disabled) {
                                  e.currentTarget.style.backgroundColor = '#e74c3c';
                                  e.currentTarget.style.color = 'white';
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!e.currentTarget.disabled) {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.color = '#e74c3c';
                                }
                              }}
                            >
                              <HiTrash size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted" style={{
                        padding: '3rem',
                        backgroundColor: '#ffffff',
                        borderRadius: '12px'
                      }}>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <FiUser size={48} className="mb-2 opacity-25" style={{ color: '#7f8c8d' }} />
                          <h5 style={{ color: '#7f8c8d', fontWeight: '500' }}>No customers found</h5>
                          <p className="mb-0" style={{ color: '#95a5a6' }}>Try adjusting your search or add a new customer</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Add/Edit User Modal */}
      <div className="modal fade" id="addUserModal" tabIndex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow-lg" style={{
            borderRadius: '16px',
            overflow: 'hidden'
          }}>
            <div className="modal-header" style={{
              backgroundColor: '#3498db',
              borderBottom: 'none',
              padding: '1.5rem'
            }}>
              <h5 className="modal-title" id="addUserModalLabel" style={{
                color: 'white',
                fontWeight: '600',
                fontSize: '1.25rem',
                display: 'flex',
                alignItems: 'center'
              }}>
                {isEditing ? (
                  <>
                    <HiPencil className="me-2" size={20} />
                    Edit Customer
                  </>
                ) : (
                  <>
                    <HiPlus className="me-2" size={20} />
                    Add New Customer
                  </>
                )}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
                onClick={resetForm}
                style={{
                  filter: 'brightness(0) invert(1)'
                }}
              ></button>
            </div>
            <div className="modal-body px-4 py-3">
              {/* Basic Details Section */}
              <h6 className="mb-3 d-flex align-items-center" style={{
                color: '#3498db',
                fontWeight: '600',
                fontSize: '1.1rem',
                padding: '0.75rem 1rem',
                backgroundColor: 'rgba(52, 152, 219, 0.1)',
                borderRadius: '8px',
                borderLeft: '4px solid #3498db',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <FiUser style={{
                  color: '#3498db',
                  fontSize: '1.5rem',
                  padding: '0.25rem',
                  backgroundColor: 'rgba(52, 152, 219, 0.2)',
                  borderRadius: '6px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
                Basic Details
              </h6>
              
              <div className="row g-3 mb-4">
                {/* First Name - REQUIRED */}
                <div className="col-md-6">
                  <label className="form-label">
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    placeholder="Enter first name"
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="col-md-6">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    placeholder="Enter last name"
                  />
                </div>

                {/* Email Address - REQUIRED */}
                <div className="col-md-6">
                  <label className="form-label">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email"
                    required
                  />
                </div>

                {/* Phone Number - REQUIRED */}
                <div className="col-md-6">
                  <label className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Enter phone number"
                    required
                  />
                </div>

                {/* WhatsApp Number */}
                <div className="col-md-6">
                  <label className="form-label">WhatsApp Contact Number</label>
                  <div className="input-group">
                    <input
                      type="tel"
                      className="form-control"
                      name="whatsapp"
                      value={formData.whatsapp}
                      onChange={handleInputChange}
                      placeholder="Enter WhatsApp number"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setFormData(prev => ({
                        ...prev,
                        whatsapp: prev.phone
                      }))}
                    >
                      Same as Phone
                    </button>
                  </div>
                </div>

                {/* Gender */}
                <div className="col-md-3">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-select"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                {/* Date of Birth */}
                <div className="col-md-3">
                  <label className="form-label">Date of Birth</label>
                  <DatePicker
                    selected={formData.dob}
                    onChange={(date) =>
                      setFormData(prev => ({
                        ...prev,
                        dob: date
                      }))
                    }
                    className="form-control"
                    maxDate={new Date()}
                    placeholderText="Select DOB"
                    dateFormat="yyyy-MM-dd"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    isClearable
                  />
                </div>

                {/* Status */}
                <div className="col-md-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                {/* Profile Image */}
                <div className="col-md-3">
                  <label className="form-label">Profile Image</label>
                  <div className="d-flex align-items-center gap-3">
                    <label htmlFor="profile-upload" className="btn btn-outline-secondary btn-sm">
                      <FiUpload className="me-1" />
                      {formData.photo ? "Change" : "Choose"}
                      <input
                        id="profile-upload"
                        type="file"
                        className="d-none"
                        accept="image/*"
                        onChange={handleImageUpload}
                      />
                    </label>
                    {getPreviewImage() && (
                      <img
                        src={getPreviewImage()}
                        alt="Preview"
                        className="rounded-circle border"
                        width="60"
                        height="60"
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                  </div>
                  {formData.photo && !isEditing && formData.photo instanceof File && (
                    <small className="text-muted d-block mt-1">
                      File: {formData.photo.name}
                    </small>
                  )}
                </div>
              </div>

              {/* Address Details Section */}
              <h6 className="mb-3 d-flex align-items-center" style={{
                color: '#27ae60',
                fontWeight: '600',
                fontSize: '1.1rem',
                padding: '0.75rem 1rem',
                backgroundColor: 'rgba(39, 174, 96, 0.1)',
                borderRadius: '8px',
                borderLeft: '4px solid #27ae60',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <FiMapPin style={{
                  color: '#27ae60',
                  fontSize: '1.5rem',
                  padding: '0.25rem',
                  backgroundColor: 'rgba(39, 174, 96, 0.2)',
                  borderRadius: '6px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
                Address Details
              </h6>
              
              <div className="row g-3 mb-4">
                {/* Address Line 1 */}
                <div className="col-md-6">
                  <label className="form-label">Address Line 1</label>
                  <input
                    type="text"
                    className="form-control"
                    name="addressLine1"
                    value={formData.addressLine1}
                    onChange={handleInputChange}
                    placeholder="Street address, P.O. box"
                  />
                </div>

                {/* Address Line 2 */}
                <div className="col-md-6">
                  <label className="form-label">Address Line 2</label>
                  <input
                    type="text"
                    className="form-control"
                    name="addressLine2"
                    value={formData.addressLine2}
                    onChange={handleInputChange}
                    placeholder="Apartment, suite, unit, building, floor, etc."
                  />
                </div>

                {/* Country */}
                <div className="col-md-6">
                  <label className="form-label">Country</label>
                  <select
                    className="form-select"
                    name="country"
                    value={formData.country}
                    onChange={handleCountryChange}
                  >
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* State */}
                <div className="col-md-6">
                  <label className="form-label">State</label>
                  <select
                    className="form-select"
                    name="state"
                    value={formData.state}
                    onChange={handleStateChange}
                    disabled={!formData.country}
                  >
                    <option value="">-- Select State --</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* District */}
                <div className="col-md-6">
                  <label className="form-label">District</label>
                  <select
                    className="form-select"
                    name="district"
                    value={formData.district}
                    onChange={handleInputChange}
                    disabled={!formData.state}
                  >
                    <option value="">-- Select District --</option>
                    {districts.map((district, idx) => (
                      <option key={idx} value={district}>
                        {district}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div className="col-md-6">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="Enter city"
                  />
                </div>

                {/* Postal/Zip Code */}
                <div className="col-md-6">
                  <label className="form-label">Postal/Zip Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="Enter postal code"
                  />
                </div>
              </div>

              {/* Toggle Buttons */}
              <div className="row mb-4 g-3">
                <div className="col-md-4">
                  <button
                    type="button"
                    className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${
                      showBusinessDetails ? "btn-outline-danger" : "btn-outline-primary"
                    }`}
                    onClick={() => setShowBusinessDetails(!showBusinessDetails)}
                  >
                    {showBusinessDetails ? (
                      <>
                        <FaMinusCircle />
                        Hide Business
                      </>
                    ) : (
                      <>
                        <FaPlusCircle />
                        Add Business
                      </>
                    )}
                  </button>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${
                      showTagsDetails ? "btn-outline-danger" : "btn-outline-primary"
                    }`}
                    onClick={() => setShowTagsDetails(!showTagsDetails)}
                  >
                    {showTagsDetails ? (
                      <>
                        <FaMinusCircle />
                        Hide Tags
                      </>
                    ) : (
                      <>
                        <FaPlusCircle />
                        Add Tags
                      </>
                    )}
                  </button>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${
                      showOtherDetails ? "btn-outline-danger" : "btn-outline-primary"
                    }`}
                    onClick={() => setShowOtherDetails(!showOtherDetails)}
                  >
                    {showOtherDetails ? (
                      <>
                        <FaMinusCircle />
                        Hide Others
                      </>
                    ) : (
                      <>
                        <FaPlusCircle />
                        Add Others
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Business Details Section */}
              {showBusinessDetails && (
                <>
                  <h6 className="mb-3 d-flex align-items-center" style={{
                    color: '#e67e22',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    padding: '0.75rem 1rem',
                    backgroundColor: 'rgba(230, 126, 34, 0.1)',
                    borderRadius: '8px',
                    borderLeft: '4px solid #e67e22',
                    marginBottom: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <FiBriefcase style={{
                      color: '#e67e22',
                      fontSize: '1.5rem',
                      padding: '0.25rem',
                      backgroundColor: 'rgba(230, 126, 34, 0.2)',
                      borderRadius: '6px',
                      width: '36px',
                      height: '36px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }} />
                    Business / Organization Details
                  </h6>
                  
                  <div className="row g-3 mb-4">
                    {/* Company Name */}
                    <div className="col-md-6">
                      <label className="form-label">Company / Organization Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                      />
                    </div>

                    {/* Business Type */}
                    <div className="col-md-6">
                      <label className="form-label">Business Type</label>
                      <select
                        className="form-select"
                        name="businessType"
                        value={formData.businessType}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Business Type --</option>
                        {businessTypes.map((type) => (
                          <option key={type._id || type.id} value={type.name}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* GST Number */}
                    <div className="col-md-6">
                      <label className="form-label">GST Number (Optional)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="gstNumber"
                        value={formData.gstNumber}
                        onChange={handleInputChange}
                        placeholder="Enter GST number"
                      />
                    </div>

                    {/* PAN Number */}
                    <div className="col-md-6">
                      <label className="form-label">PAN Number (Optional)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="panNumber"
                        value={formData.panNumber}
                        onChange={handleInputChange}
                        placeholder="Enter PAN number"
                      />
                    </div>

                    {/* Business Address */}
                    <div className="col-md-12">
                      <label className="form-label">Business Address</label>
                      <input
                        type="text"
                        className="form-control"
                        name="businessAddress"
                        value={formData.businessAddress}
                        onChange={handleInputChange}
                        placeholder="Enter full business address"
                      />
                    </div>

                    {/* Business Website */}
                    <div className="col-md-6">
                      <label className="form-label">Business Website</label>
                      <input
                        type="text"
                        className="form-control"
                        name="website"
                        value={formData.website}
                        onChange={handleInputChange}
                        placeholder="https://example.com"
                      />
                    </div>

                    {/* Social Links Section */}
                    <div className="col-12 mt-3">
                      <h6 className="text-muted text-uppercase small">Social Media Links</h6>
                      <hr className="mt-1" />
                    </div>

                    {/* Social Links */}
                    {[
                      { name: 'facebook', icon: <FiFacebook />, label: 'Facebook', placeholder: 'https://facebook.com/username' },
                      { name: 'instagram', icon: <FiInstagram />, label: 'Instagram', placeholder: 'https://instagram.com/username' },
                      { name: 'twitter', icon: <FiTwitter />, label: 'X (Twitter)', placeholder: 'https://twitter.com/username' },
                      { name: 'linkedin', icon: <FiLinkedin />, label: 'LinkedIn', placeholder: 'https://linkedin.com/in/username' },
                      { name: 'behance', icon: <FiCodepen />, label: 'Behance', placeholder: 'https://behance.net/username' },
                      { name: 'youtube', icon: <FiYoutube />, label: 'YouTube', placeholder: 'https://youtube.com/@channel' }
                    ].map((social) => (
                      <div className="col-md-6" key={social.name}>
                        <label className="form-label">{social.label}</label>
                        <input
                          type="text"
                          className="form-control"
                          name={social.name}
                          value={formData[social.name]}
                          onChange={handleInputChange}
                          placeholder={social.placeholder}
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Other Fields Section */}
              {showOtherDetails && (
                <>
                  <h6 className="mb-3 d-flex align-items-center" style={{
                    color: '#9b59b6',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    padding: '0.75rem 1rem',
                    backgroundColor: 'rgba(155, 89, 182, 0.1)',
                    borderRadius: '8px',
                    borderLeft: '4px solid #9b59b6',
                    marginBottom: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <FiUserPlus style={{
                      color: '#9b59b6',
                      fontSize: '1.5rem',
                      padding: '0.25rem',
                      backgroundColor: 'rgba(155, 89, 182, 0.2)',
                      borderRadius: '6px',
                      width: '36px',
                      height: '36px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }} />
                    Other Fields
                  </h6>
                  
                  <div className="row g-3 mb-4">
                    {/* Referred By */}
                    <div className="col-md-6">
                      <label className="form-label">Referred By</label>
                      <input
                        type="text"
                        className="form-control"
                        name="ReferredBy"
                        value={formData.ReferredBy}
                        onChange={handleInputChange}
                        placeholder="Who referred this customer?"
                      />
                    </div>

                    {/* Preferred Language */}
                    <div className="col-md-6">
                      <label className="form-label">Preferred Language</label>
                      <select
                        className="form-select"
                        name="Language"
                        value={formData.Language}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Language --</option>
                        {languages.map((lang) => (
                          <option key={lang._id || lang.id} value={lang.name}>
                            {lang.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {/* Tags/Labels Section */}
              {showTagsDetails && (
                <>
                  <h6 className="mb-3 d-flex align-items-center" style={{
                    color: '#2c3e50',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    padding: '0.75rem 1rem',
                    backgroundColor: 'rgba(44, 62, 80, 0.1)',
                    borderRadius: '8px',
                    borderLeft: '4px solid #2c3e50',
                    marginBottom: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <FiTag style={{
                      color: '#2c3e50',
                      fontSize: '1.5rem',
                      padding: '0.25rem',
                      backgroundColor: 'rgba(44, 62, 80, 0.2)',
                      borderRadius: '6px',
                      width: '36px',
                      height: '36px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }} />
                    Tags / Labels
                  </h6>
                  
                  <div className="row g-3 mb-4">
                    {/* Notes/Remarks */}
                    <div className="col-md-6">
                      <label className="form-label">Notes / Remarks</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Remarks"
                        value={formData.Remarks}
                        onChange={handleInputChange}
                        placeholder="Enter any additional notes"
                      />
                    </div>

                    {/* Tags/Labels */}
                    <div className="col-md-6">
                      <label className="form-label">Tags / Labels</label>
                      <select
                        className="form-select"
                        name="Tags"
                        value={formData.Tags}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Tag / Label --</option>
                        {tags.map((tag) => (
                          <option key={tag._id || tag.id} value={tag.name}>
                            {tag.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer bg-light rounded-bottom-4 px-4 py-3">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                onClick={resetForm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleAddOrEditUser}
                disabled={!formData.firstName || !formData.email || !formData.phone}
              >
                {isEditing ? "Update Customer" : "Add Customer"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}